import Vue from 'vue';
import * as moment from 'moment';
import VueMoment from 'vue-moment';

import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { zhTW } from './helpers/moment-locale';

moment.locale('zh-Hant-my-settings', zhTW);
moment.defineLocale('zh-Hant', { parentLocale: 'zh-TW' });
Vue.use(VueMoment, { moment });

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
